import { render, staticRenderFns } from "./BuyerOrderDetail.vue?vue&type=template&id=282154fa&"
import script from "./BuyerOrderDetail.vue?vue&type=script&lang=js&"
export * from "./BuyerOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports